import { PATH, TITLE } from "./constants/appConstants";
import AddHelpline from "./containers/addHelpline";
import AddNews from "./containers/addNews";
import AddStories from "./containers/addStories";
import Applicants from "./containers/applicants";
import Approvals from "./containers/approval";
import CreateAwards from "./containers/awards/createAwards";
import Awards from "./containers/awards/viewAwards/viewAwards";
import City from "./containers/city";
import Events from "./containers/events";
import FamilyTree from "./containers/familyTree";
import HelplineContacts from "./containers/helplineContacts";
import Home from "./containers/home";
import Jamaats from "./containers/jamaats";
import Members from "./containers/members";
import News from "./containers/news";
import NewsApproval from "./containers/newsApproval/newsApproval";
import Notifications from "./containers/notifications";
import NotificationList from "./containers/notificationsList";
import Profile from "./containers/profile";
import Requests from "./containers/requests";
import ReservedCodes from "./containers/reservedCodes";
import SingleHelpline from "./containers/singleHelpline";
import SingleStories from "./containers/singleStories/singleStories";
import SingleNews from "./containers/singlenews";
import Stories from "./containers/stories";
// const Engagements = React.lazy(() => import(`./containers/engagements`));

const routes = [
  {
    path: PATH.DASHBOARD_SCREEN,
    exact: true,
    name: TITLE.DASHBOARD_SCREEN,
  },
  {
    path: PATH.HOME_SCREEN,
    name: TITLE.HOME_SCREEN,
    component: Home,
  },
  {
    path: PATH.CITY_SCREEN,
    name: TITLE.CITY_SCREEN,
    component: City,
  },
  {
    path: PATH.APPLICANTS_SCREEN,
    name: TITLE.APPLICANTS_SCREEN,
    component: Applicants,
  },
  {
    path: PATH.MEMBERS_SCREEN,
    name: TITLE.MEMBERS_SCREEN,
    component: Members,
  },
  {
    path: PATH.JAMAATS_SCREEN,
    name: TITLE.JAMAATS_SCREEN,
    component: Jamaats,
  },
  {
    path: PATH.RESERVED_CODES_SCREEN,
    name: TITLE.RESERVED_CODES_SCREEN,
    component: ReservedCodes,
  },
  {
    path: PATH.APPROVALS_SCREEN,
    name: TITLE.APPROVALS_SCREEN,
    component: Approvals,
  },
  {
    path: PATH.REQUESTS,
    name: TITLE.REQUESTS,
    component: Requests,
  },
  {
    path: PATH.FAMILY_TREE,
    name: TITLE.FAMILY_TREE,
    component: FamilyTree,
  },
  {
    path: PATH.PROFILE_SCREEN,
    name: TITLE.PROFILE_SCREEN,
    component: Profile,
  },
  {
    path: PATH.NOTIFICATIONS_SCREEN,
    name: TITLE.NOTIFICATIONS_SCREEN,
    component: Notifications,
  },
  {
    path: PATH.NOTIFICATION_LIST_SCREEN,
    name: TITLE.NOTIFICATION_LIST_SCREEN,
    component: NotificationList,
  },
  {
    path: PATH.NEWS_SCREEN,
    name: TITLE.NEWS_SCREEN,
    component: News,
  },
  {
    path: PATH.STORIES_SCREEN,
    name: TITLE.STORIES_SCREEN,
    component: Stories,
  },
  {
    path: PATH.ADD_STORIES_SCREEN,
    name: TITLE.ADD_STORIES_SCREEN,
    component: AddStories,
  },
  {
    path: PATH.ADD_NEWS_SCREEN,
    name: TITLE.ADD_NEWS_SCREEN,
    component: AddNews,
  },
  {
    path: PATH.UPDATE_NEWS_SCREEN,
    name: TITLE.UPDATE_NEWS_SCREEN,
    component: AddNews,
  },
  {
    path: PATH.UPDATE_STORY_SCREEN,
    name: TITLE.UPDATE_STORY_SCREEN,
    component: AddStories,
  },
  {
    path: PATH.NEWS_APPROVALS_SCREEN,
    name: TITLE.NEWS_APPROVALS_SCREEN,
    component: NewsApproval,
  },
  {
    path: PATH.NEWS_DETAILS_SCREEN,
    name: TITLE.NEWS_DETAILS_SCREEN,
    component: SingleNews,
  },
  {
    path: PATH.EVENTS_SCREEN,
    name: TITLE.EVENTS_SCREEN,
    component: Events,
  },
  {
    path: PATH.STORIES_DETAILS_SCREEN,
    name: TITLE.STORIES_DETAILS_SCREEN,
    component: SingleStories,
  },
  {
    path: PATH.ASK_HELP,
    name: TITLE.ASK_HELP,
    component: AddHelpline,
  },
  {
    path: PATH.HELPLINE_CONTACTS,
    name: TITLE.HELPLINE_CONTACTS,
    component: HelplineContacts,
  },
  {
    path: PATH.HELPLINE_DETAILS,
    name: TITLE.HELPLINE_DETAILS,
    component: SingleHelpline,
  },
  {
    path: PATH.AWARDS_ADMIN,
    name: TITLE.AWARDS_ADMIN,
    component: CreateAwards,
  },
  {
    path: PATH.AWARDS,
    name: TITLE.AWARDS,
    component: Awards,
  },
];

export default routes;
